import { trpc } from '@/data-loaders';

export const useDisciplineList = (schoolId: number) => {
  return trpc.schoolUnit.getDisciplineBySchoolIdList.useQuery(
    { schoolId },
    {
      retry: false,
      cacheTime: 1000 * 60 * 60 * 24, // 1 day
      enabled: !!schoolId,
    },
  );
};
